// Order Management - Orders
import profileImg01 from "../../assets/images/AdminPortalImages/DataTableImgs/profileImg.png";
import profileImg02 from "../../assets/images/AdminPortalImages/DataTableImgs/profileImg02.png";
import MediaImg from "../../assets/images/AdminPortalImages/DataTableImgs/mediaImg.png";

export const ordersTableData = [
    {
        id: "#1234",
        customerName: "Full name",
        customerImage: profileImg01,
        totalPayment: "$40",
        lastUpdate: "Oct 4, 2024",
        status: "Shipped",
        paymentStatus: "Paid",
        orderDate: "Oct 4, 2024",
    },
    {
        id: "#5678",
        customerName: "Jane Doe",
        customerImage: profileImg02,
        totalPayment: "$60",
        lastUpdate: "Oct 5, 2024",
        status: "Pending",
        paymentStatus: "Unpaid",
        orderDate: "Oct 5, 2024",
    },
    {
        id: "#9111",
        customerName: "John Smith",
        customerImage: profileImg01,
        totalPayment: "$75",
        lastUpdate: "Oct 6, 2024",
        status: "Shipped",
        paymentStatus: "Paid",
        orderDate: "Oct 6, 2024",
    },
    {
        id: "#1213",
        customerName: "Jane Doe",
        customerImage: profileImg02,
        totalPayment: "$60",
        lastUpdate: "Oct 5, 2024",
        status: "Pending",
        paymentStatus: "Unpaid",
        orderDate: "Oct 5, 2024",
    },
    {
        id: "#1415",
        customerName: "Full name",
        customerImage: profileImg01,
        totalPayment: "$40",
        lastUpdate: "Oct 4, 2024",
        status: "Shipped",
        paymentStatus: "Paid",
        orderDate: "Oct 4, 2024",
    },
    {
        id: "#1617",
        customerName: "Jane Doe",
        customerImage: profileImg02,
        totalPayment: "$60",
        lastUpdate: "Oct 5, 2024",
        status: "Pending",
        paymentStatus: "Unpaid",
        orderDate: "Oct 5, 2024",
    },
    {
        id: "#1819",
        customerName: "John Smith",
        customerImage: profileImg01,
        totalPayment: "$75",
        lastUpdate: "Oct 6, 2024",
        status: "Shipped",
        paymentStatus: "Paid",
        orderDate: "Oct 6, 2024",
    },
    {
        id: "#2021",
        customerName: "Jane Doe",
        customerImage: profileImg02,
        totalPayment: "$60",
        lastUpdate: "Oct 5, 2024",
        status: "Pending",
        paymentStatus: "Unpaid",
        orderDate: "Oct 5, 2024",
    },
    {
        id: "#2223",
        customerName: "John Smith",
        customerImage: profileImg01,
        totalPayment: "$75",
        lastUpdate: "Oct 6, 2024",
        status: "Shipped",
        paymentStatus: "Paid",
        orderDate: "Oct 6, 2024",
    },
    {
        id: "#2425",
        customerName: "Jane Doe",
        customerImage: profileImg02,
        totalPayment: "$60",
        lastUpdate: "Oct 5, 2024",
        status: "Pending",
        paymentStatus: "Unpaid",
        orderDate: "Oct 5, 2024",
    },
    {
        id: "#2627",
        customerName: "John Smith",
        customerImage: profileImg01,
        totalPayment: "$75",
        lastUpdate: "Oct 6, 2024",
        status: "Shipped",
        paymentStatus: "Paid",
        orderDate: "Oct 6, 2024",
    },
];

// Order Management - Order Fulfillment
export const inventoryLevelsTableData = [
    {
        sellerId: "#1234",
        productSku: "SHOE-RUN-RD-10",
        productName: "Nike Jordan",
        stock: "Low",
        allocatedOrders: 12,
        availableNewOrders: 20,
    },
    {
        sellerId: "#5678",
        productSku: "SHOE-RUN-RD-10",
        productName: "Black Handbag",
        stock: "Ample",
        allocatedOrders: 150,
        availableNewOrders: 300,
    },
    {
        sellerId: "#9101",
        productSku: "SHOE-RUN-RD-10",
        productName: "Nike Jordan",
        stock: "Low",
        allocatedOrders: 12,
        availableNewOrders: 20,
    },
    {
        sellerId: "#1213",
        productSku: "SHOE-RUN-RD-10",
        productName: "Black Handbag",
        stock: "Ample",
        allocatedOrders: 150,
        availableNewOrders: 300,
    },
];

export const shippingCarrierTableData = [
    {
        carrier: "FedEx",
        deliveryPercentage: "75%",
        avgTime: 2,
        damagedPercentage: "2%",
        lostPercentage: "2%",
    },
    {
        carrier: "FedEx",
        deliveryPercentage: "75%",
        avgTime: 2,
        damagedPercentage: "2%",
        lostPercentage: "2%",
    },
    {
        carrier: "FedEx",
        deliveryPercentage: "75%",
        avgTime: 2,
        damagedPercentage: "2%",
        lostPercentage: "2%",
    },
    {
        carrier: "FedEx",
        deliveryPercentage: "75%",
        avgTime: 2,
        damagedPercentage: "2%",
        lostPercentage: "2%",
    },
];

// Order Management - Returns and Refunds
export const returnTrackingTableData = [
    {
        returnId: "R-45367",
        orderId: "#1234",
        sellerId: "#4567",
        customerName: "Full name",
        productName: "Nike Jordan",
        returnStatus: "Processing",
        sellerApproval: "Approved",
        date: "June 9,2023",
    },
    {
        returnId: "R-45367",
        orderId: "#1234",
        sellerId: "#4567",
        customerName: "Full name",
        productName: "Black Handbag",
        returnStatus: "On Hold",
        sellerApproval: "Pending",
        date: "June 9,2023",
    },
    {
        returnId: "R-45367",
        orderId: "#1234",
        sellerId: "#4567",
        customerName: "Full name",
        productName: "Nike Jordan",
        returnStatus: "Processing",
        sellerApproval: "Approved",
        date: "June 9,2023",
    },
    {
        returnId: "R-45367",
        orderId: "#1234",
        sellerId: "#4567",
        customerName: "Full name",
        productName: "Black Handbag",
        returnStatus: "On Hold",
        sellerApproval: "Pending",
        date: "June 9,2023",
    },
    {
        returnId: "R-45367",
        orderId: "#1234",
        sellerId: "#4567",
        customerName: "Full name",
        productName: "Nike Jordan",
        returnStatus: "Processing",
        sellerApproval: "Approved",
        date: "June 9,2023",
    },
    {
        returnId: "R-45367",
        orderId: "#1234",
        sellerId: "#4567",
        customerName: "Full name",
        productName: "Black Handbag",
        returnStatus: "On Hold",
        sellerApproval: "Pending",
        date: "June 9,2023",
    },
];

export const refundTrackingTableData = [
    {
        refundId: "RF-764",
        returnId: "R-45367",
        sellerId: "#4567",
        customerName: "Full name",
        refundAmount: "$50",
        refundStatus: "Approved",
    },
    {
        refundId: "RF-764",
        returnId: "R-45367",
        sellerId: "#4567",
        customerName: "Full name",
        refundAmount: "$30",
        refundStatus: "Pending",
    },
    {
        refundId: "RF-764",
        returnId: "R-45367",
        sellerId: "#4567",
        customerName: "Full name",
        refundAmount: "$50",
        refundStatus: "Approved",
    },
    {
        refundId: "RF-764",
        returnId: "R-45367",
        sellerId: "#4567",
        customerName: "Full name",
        refundAmount: "$30",
        refundStatus: "Pending",
    },
    {
        refundId: "RF-764",
        returnId: "R-45367",
        sellerId: "#4567",
        customerName: "Full name",
        refundAmount: "$50",
        refundStatus: "Approved",
    },
    {
        refundId: "RF-764",
        returnId: "R-45367",
        sellerId: "#4567",
        customerName: "Full name",
        refundAmount: "$30",
        refundStatus: "Pending",
    },
];

// Marketing & Promotions - Banners Campaigns
export const maelanoCampaignsTableData = [
    {
        imgSrc: MediaImg,
        campaignId: "CM-001",
        campaignName: "Flash Deals",
        category: "Clothing",
        subDivision: "Online",
        status: "Upcoming",
        startDate: "Oct 4,2024",
        endDate: "Nov 4,2024",
    },
    {
        imgSrc: MediaImg,
        campaignId: "CM-001",
        campaignName: "Flash Deals",
        category: "Clothing",
        subDivision: "Online",
        status: "Active",
        startDate: "Oct 4,2024",
        endDate: "Nov 4,2024",
    },
    {
        imgSrc: MediaImg,
        campaignId: "CM-001",
        campaignName: "Flash Deals",
        category: "Clothing",
        subDivision: "Online",
        status: "Upcoming",
        startDate: "Oct 4,2024",
        endDate: "Nov 4,2024",
    },
    {
        imgSrc: MediaImg,
        campaignId: "CM-001",
        campaignName: "Flash Deals",
        category: "Clothing",
        subDivision: "Online",
        status: "Active",
        startDate: "Oct 4,2024",
        endDate: "Nov 4,2024",
    },
];

export const invitationListsTableData = [
    {
        campaignId: "CN-1001",
        campaignTitle: "Name",
        imgSrc: MediaImg,
        sellerInvitations: 86,
        sellerParticipated: 80,
        startDate: "Oct 4,2024",
        endDate: "Nov 4,2024",
        toggleState: true,
    },
    {
        campaignId: "CN-1001",
        campaignTitle: "Name",
        imgSrc: MediaImg,
        sellerInvitations: 86,
        sellerParticipated: 80,
        startDate: "Oct 4,2024",
        endDate: "Nov 4,2024",
        toggleState: false,
    },
    {
        campaignId: "CN-1001",
        campaignTitle: "Name",
        imgSrc: MediaImg,
        sellerInvitations: 86,
        sellerParticipated: 80,
        startDate: "Oct 4,2024",
        endDate: "Nov 4,2024",
        toggleState: true,
    },
    {
        campaignId: "CN-1001",
        campaignTitle: "Name",
        imgSrc: MediaImg,
        sellerInvitations: 86,
        sellerParticipated: 80,
        startDate: "Oct 4,2024",
        endDate: "Nov 4,2024",
        toggleState: false,
    },
];

export const inStoreCampaignsTableData = [
    {
        bannerId: "BN-1001",
        title: "Name",
        sellerId: "#5542",
        landingPage: "URL",
        linkedinProduct: 54,
        status: "Active",
        startDate: "Oct 4,2024",
        endDate: "Nov 4,2024",
        toggleState: true,
    },
    {
        bannerId: "BN-1001",
        title: "Name",
        sellerId: "#5542",
        landingPage: "URL",
        linkedinProduct: 54,
        status: "Inactive",
        startDate: "Oct 4,2024",
        endDate: "Nov 4,2024",
        toggleState: false,
    },
    {
        bannerId: "BN-1001",
        title: "Name",
        sellerId: "#5542",
        landingPage: "URL",
        linkedinProduct: 54,
        status: "Active",
        startDate: "Oct 4,2024",
        endDate: "Nov 4,2024",
        toggleState: true,
    },
    {
        bannerId: "BN-1001",
        title: "Name",
        sellerId: "#5542",
        landingPage: "URL",
        linkedinProduct: 54,
        status: "Inactive",
        startDate: "Oct 4,2024",
        endDate: "Nov 4,2024",
        toggleState: false,
    },
    {
        bannerId: "BN-1001",
        title: "Name",
        sellerId: "#5542",
        landingPage: "URL",
        linkedinProduct: 54,
        status: "Active",
        startDate: "Oct 4,2024",
        endDate: "Nov 4,2024",
        toggleState: true,
    },
    {
        bannerId: "BN-1001",
        title: "Name",
        sellerId: "#5542",
        landingPage: "URL",
        linkedinProduct: 54,
        status: "Inactive",
        startDate: "Oct 4,2024",
        endDate: "Nov 4,2024",
        toggleState: false,
    },
];

// Marketing & Promotions - Coupons
export const platformGeneratedTableData = [
    {
        couponCode: "J4R20",
        description: "Lorem Ipsum",
        discountType: "Percentage off",
        discountValue: "20% Off",
        status: "Active",
        startDate: "Oct 4,2024",
        endDate: "Nov 4,2024",
    },
    {
        couponCode: "J4R20",
        description: "Lorem Ipsum",
        discountType: "Percentage off",
        discountValue: "20% Off",
        status: "Inactive",
        startDate: "Oct 4,2024",
        endDate: "Nov 4,2024",
    },
    {
        couponCode: "J4R20",
        description: "Lorem Ipsum",
        discountType: "Percentage off",
        discountValue: "20% Off",
        status: "Active",
        startDate: "Oct 4,2024",
        endDate: "Nov 4,2024",
    },
    {
        couponCode: "J4R20",
        description: "Lorem Ipsum",
        discountType: "Percentage off",
        discountValue: "20% Off",
        status: "Inactive",
        startDate: "Oct 4,2024",
        endDate: "Nov 4,2024",
    },
    {
        couponCode: "J4R20",
        description: "Lorem Ipsum",
        discountType: "Percentage off",
        discountValue: "20% Off",
        status: "Active",
        startDate: "Oct 4,2024",
        endDate: "Nov 4,2024",
    },
    {
        couponCode: "J4R20",
        description: "Lorem Ipsum",
        discountType: "Percentage off",
        discountValue: "20% Off",
        status: "Inactive",
        startDate: "Oct 4,2024",
        endDate: "Nov 4,2024",
    },
];

export const sellerGeneratedTableData = [
    {
        couponCode: "J4R20",
        description: "Lorem Ipsum",
        sellerId: "#764",
        discountType: "Limited Time",
        discountValue: "20% Off",
        status: "Active",
        startDate: "Oct 4,2024",
        endDate: "Nov 4,2024",
        toggleState: true,
    },
    {
        couponCode: "J4R20",
        description: "Lorem Ipsum",
        sellerId: "#764",
        discountType: "Limited Time",
        discountValue: "20% Off",
        status: "Inactive",
        startDate: "Oct 4,2024",
        endDate: "Nov 4,2024",
        toggleState: false,
    },
    {
        couponCode: "J4R20",
        description: "Lorem Ipsum",
        sellerId: "#764",
        discountType: "Limited Time",
        discountValue: "20% Off",
        status: "Active",
        startDate: "Oct 4,2024",
        endDate: "Nov 4,2024",
        toggleState: true,
    },
    {
        couponCode: "J4R20",
        description: "Lorem Ipsum",
        sellerId: "#764",
        discountType: "Limited Time",
        discountValue: "20% Off",
        status: "Inactive",
        startDate: "Oct 4,2024",
        endDate: "Nov 4,2024",
        toggleState: false,
    },
    {
        couponCode: "J4R20",
        description: "Lorem Ipsum",
        sellerId: "#764",
        discountType: "Limited Time",
        discountValue: "20% Off",
        status: "Active",
        startDate: "Oct 4,2024",
        endDate: "Nov 4,2024",
        toggleState: true,
    },
    {
        couponCode: "J4R20",
        description: "Lorem Ipsum",
        sellerId: "#764",
        discountType: "Limited Time",
        discountValue: "20% Off",
        status: "Inactive",
        startDate: "Oct 4,2024",
        endDate: "Nov 4,2024",
        toggleState: false,
    },
];

// Marketing & Promotions - Vouchers
export const platformGeneratedVouchersTableData = [
    {
        voucherName: "Holiday Sale",
        voucherCode: "H-9896",
        voucherType: "Store Credit",
        validityPeriod: "22/9/24-24/10/24",
        value: "$15",
        conditions: "Min order $55",
        applicability: "New users",
        redemption: "20 Redeemed",
        status: "Active",
    },
    {
        voucherName: "Holiday Sale",
        voucherCode: "H-9896",
        voucherType: "Store Credit",
        validityPeriod: "22/9/24-24/10/24",
        value: "$15",
        conditions: "Min order $55",
        applicability: "New users",
        redemption: "20 Redeemed",
        status: "Expired",
    },
    {
        voucherName: "Holiday Sale",
        voucherCode: "H-9896",
        voucherType: "Store Credit",
        validityPeriod: "22/9/24-24/10/24",
        value: "$15",
        conditions: "Min order $55",
        applicability: "New users",
        redemption: "20 Redeemed",
        status: "Active",
    },
    {
        voucherName: "Holiday Sale",
        voucherCode: "H-9896",
        voucherType: "Store Credit",
        validityPeriod: "22/9/24-24/10/24",
        value: "$15",
        conditions: "Min order $55",
        applicability: "New users",
        redemption: "20 Redeemed",
        status: "Expired",
    },
];

export const sellerGeneratedVouchersTableData = [
    {
        voucherName: "Full Name",
        voucherCode: "001",
        voucherType: "Store Credit",
        sellerName: "John Doe",
        validityPeriod: "11/22/2024-12/22/2024",
        value: "$50",
        conditions: "Min order $200",
        applicability: "Online Store",
        redemption: "One time",
        status: "Active",
    },
    {
        voucherName: "Full Name",
        voucherCode: "001",
        voucherType: "Product Specific",
        sellerName: "John Doe",
        validityPeriod: "11/22/2024-12/22/2024",
        value: "$50",
        conditions: "Min order $200",
        applicability: "Online Store",
        redemption: "One time",
        status: "Active",
    },
    {
        voucherName: "Full Name",
        voucherCode: "001",
        voucherType: "Store Credit",
        sellerName: "John Doe",
        validityPeriod: "11/22/2024-12/22/2024",
        value: "$50",
        conditions: "Min order $200",
        applicability: "Online Store",
        redemption: "One time",
        status: "Active",
    },
    {
        voucherName: "Full Name",
        voucherCode: "001",
        voucherType: "Product Specific",
        sellerName: "John Doe",
        validityPeriod: "11/22/2024-12/22/2024",
        value: "$50",
        conditions: "Min order $200",
        applicability: "Online Store",
        redemption: "One time",
        status: "Active",
    },
];

// Marketing & Promotions - Free Delivery
export const platformProvidedTableData = [
    {
        offerId: "U7R50",
        promotionPeriod: "05/02/25-10/02/25",
        deliveryZone: "Lahore, Pakistan",
        applicability: "Specific categories",
        budget: "$5000",
        status: "Active",
        toggleState: true,
    },
    {
        offerId: "U7R50",
        promotionPeriod: "05/02/25-10/02/25",
        deliveryZone: "Lahore, Pakistan",
        applicability: "Specific categories",
        budget: "$5000",
        status: "Inactive",
        toggleState: false,
    },
    {
        offerId: "U7R50",
        promotionPeriod: "05/02/25-10/02/25",
        deliveryZone: "Lahore, Pakistan",
        applicability: "Specific categories",
        budget: "$5000",
        status: "Active",
        toggleState: true,
    },
    {
        offerId: "U7R50",
        promotionPeriod: "05/02/25-10/02/25",
        deliveryZone: "Lahore, Pakistan",
        applicability: "Specific categories",
        budget: "$5000",
        status: "Inactive",
        toggleState: false,
    },
    {
        offerId: "U7R50",
        promotionPeriod: "05/02/25-10/02/25",
        deliveryZone: "Lahore, Pakistan",
        applicability: "Specific categories",
        budget: "$5000",
        status: "Active",
        toggleState: true,
    },
    {
        offerId: "U7R50",
        promotionPeriod: "05/02/25-10/02/25",
        deliveryZone: "Lahore, Pakistan",
        applicability: "Specific categories",
        budget: "$5000",
        status: "Inactive",
        toggleState: false,
    },
];

export const sellerProvidedTableData = [
    {
        offerId: "U7R50",
        sellerId: "#5474",
        promotionPeriod: "05/02/25-10/02/25",
        deliveryZone: "Lahore, Pakistan",
        applicability: "Specific products",
        minOrderValue: "$50",
        status: "Active",
        toggleState: true,
    },
    {
        offerId: "U7R50",
        sellerId: "#5474",
        promotionPeriod: "05/02/25-10/02/25",
        deliveryZone: "Lahore, Pakistan",
        applicability: "Specific products",
        minOrderValue: "$50",
        status: "Inactive",
        toggleState: false,
    },
    {
        offerId: "U7R50",
        sellerId: "#5474",
        promotionPeriod: "05/02/25-10/02/25",
        deliveryZone: "Lahore, Pakistan",
        applicability: "Specific products",
        minOrderValue: "$50",
        status: "Active",
        toggleState: true,
    },
    {
        offerId: "U7R50",
        sellerId: "#5474",
        promotionPeriod: "05/02/25-10/02/25",
        deliveryZone: "Lahore, Pakistan",
        applicability: "Specific products",
        minOrderValue: "$50",
        status: "Inactive",
        toggleState: false,
    },
    {
        offerId: "U7R50",
        sellerId: "#5474",
        promotionPeriod: "05/02/25-10/02/25",
        deliveryZone: "Lahore, Pakistan",
        applicability: "Specific products",
        minOrderValue: "$50",
        status: "Active",
        toggleState: true,
    },
    {
        offerId: "U7R50",
        sellerId: "#5474",
        promotionPeriod: "05/02/25-10/02/25",
        deliveryZone: "Lahore, Pakistan",
        applicability: "Specific products",
        minOrderValue: "$50",
        status: "Inactive",
        toggleState: false,
    },
];

// Marketing & Promotions - Push Notifications
export const pushNotificationsTableData = [
    {
        title: "New Launch",
        type: "Promotional",
        imgSrc: MediaImg,
        count: 1500,
        status: "Scheduled",
    },
    {
        title: "New Launch",
        type: "Promotional",
        imgSrc: MediaImg,
        count: 1500,
        status: "On-going",
    },
    {
        title: "New Launch",
        type: "Promotional",
        imgSrc: MediaImg,
        count: 1500,
        status: "Scheduled",
    },
    {
        title: "New Launch",
        type: "Promotional",
        imgSrc: MediaImg,
        count: 1500,
        status: "On-going",
    },
    {
        title: "New Launch",
        type: "Promotional",
        imgSrc: MediaImg,
        count: 1500,
        status: "Scheduled",
    },
    {
        title: "New Launch",
        type: "Promotional",
        imgSrc: MediaImg,
        count: 1500,
        status: "On-going",
    },
];

export const performanceTrackingTableData = [
    {
        title: "Holiday Sale",
        sentDate: "Oct 4,2024",
        delivered: 500,
        opened: 450,
        ctr: "12.7%",
        conversions: 300,
    },
    {
        title: "Holiday Sale",
        sentDate: "Oct 4,2024",
        delivered: 500,
        opened: 450,
        ctr: "12.7%",
        conversions: 300,
    },
    {
        title: "Holiday Sale",
        sentDate: "Oct 4,2024",
        delivered: 500,
        opened: 450,
        ctr: "12.7%",
        conversions: 300,
    },
    {
        title: "Holiday Sale",
        sentDate: "Oct 4,2024",
        delivered: 500,
        opened: 450,
        ctr: "12.7%",
        conversions: 300,
    },
    {
        title: "Holiday Sale",
        sentDate: "Oct 4,2024",
        delivered: 500,
        opened: 450,
        ctr: "12.7%",
        conversions: 300,
    },
    {
        title: "Holiday Sale",
        sentDate: "Oct 4,2024",
        delivered: 500,
        opened: 450,
        ctr: "12.7%",
        conversions: 300,
    },
];

// Marketing & Promotions - Seller Picks
export const sellerPicksManagementTableData = [
    {
        pickId: "P-1001",
        productName: "Lorem Ipsum",
        sellerId: "#5542",
        category: "Home Essentials",
        status: "Active",
        startDate: "Oct 4,2024",
        endDate: "Nov 4,2024",
        toggleState: true,
    },
    {
        pickId: "P-1001",
        productName: "Lorem Ipsum",
        sellerId: "#5542",
        category: "Home Essentials",
        status: "Inactive",
        startDate: "Oct 4,2024",
        endDate: "Nov 4,2024",
        toggleState: false,
    },
    {
        pickId: "P-1001",
        productName: "Lorem Ipsum",
        sellerId: "#5542",
        category: "Home Essentials",
        status: "Active",
        startDate: "Oct 4,2024",
        endDate: "Nov 4,2024",
        toggleState: true,
    },
    {
        pickId: "P-1001",
        productName: "Lorem Ipsum",
        sellerId: "#5542",
        category: "Home Essentials",
        status: "Inactive",
        startDate: "Oct 4,2024",
        endDate: "Nov 4,2024",
        toggleState: false,
    },
    {
        pickId: "P-1001",
        productName: "Lorem Ipsum",
        sellerId: "#5542",
        category: "Home Essentials",
        status: "Active",
        startDate: "Oct 4,2024",
        endDate: "Nov 4,2024",
        toggleState: true,
    },
    {
        pickId: "P-1001",
        productName: "Lorem Ipsum",
        sellerId: "#5542",
        category: "Home Essentials",
        status: "Inactive",
        startDate: "Oct 4,2024",
        endDate: "Nov 4,2024",
        toggleState: false,
    },
];

export const picksPerformanceTableData = [
    {
        pickId: "P-1001",
        productName: "Lorem Ipsum",
        sellerId: "#7764",
        clicks: 50,
        views: 200,
        conversionRate: "5%",
        sales: "$1000",
        revenue: "$100",
        aov: "$90",
    },
    {
        pickId: "P-1001",
        productName: "Lorem Ipsum",
        sellerId: "#7764",
        clicks: 50,
        views: 200,
        conversionRate: "5%",
        sales: "$1000",
        revenue: "$100",
        aov: "$90",
    },
    {
        pickId: "P-1001",
        productName: "Lorem Ipsum",
        sellerId: "#7764",
        clicks: 50,
        views: 200,
        conversionRate: "5%",
        sales: "$1000",
        revenue: "$100",
        aov: "$90",
    },
    {
        pickId: "P-1001",
        productName: "Lorem Ipsum",
        sellerId: "#7764",
        clicks: 50,
        views: 200,
        conversionRate: "5%",
        sales: "$1000",
        revenue: "$100",
        aov: "$90",
    },
    {
        pickId: "P-1001",
        productName: "Lorem Ipsum",
        sellerId: "#7764",
        clicks: 50,
        views: 200,
        conversionRate: "5%",
        sales: "$1000",
        revenue: "$100",
        aov: "$90",
    },
    {
        pickId: "P-1001",
        productName: "Lorem Ipsum",
        sellerId: "#7764",
        clicks: 50,
        views: 200,
        conversionRate: "5%",
        sales: "$1000",
        revenue: "$100",
        aov: "$90",
    },
];

// Marketing & Promotions - Social Media Marketing
export const smmScheduleTableData = [
    {
        date: "10-11-2024",
        time: "09:37",
        platform: "Facebook",
        content: "Announcing Our New Blog Posts!",
        status: "Scheduled",
    },
    {
        date: "10-11-2024",
        time: "09:37",
        platform: "Instagram",
        content: "Announcing Our New Blog Posts!",
        status: "Scheduled",
    },
    {
        date: "10-11-2024",
        time: "09:37",
        platform: "LinkedIn",
        content: "Announcing Our New Blog Posts!",
        status: "Scheduled",
    },
    {
        date: "10-11-2024",
        time: "09:37",
        platform: "Facebook",
        content: "Announcing Our New Blog Posts!",
        status: "Scheduled",
    },
    {
        date: "10-11-2024",
        time: "09:37",
        platform: "Instagram",
        content: "Announcing Our New Blog Posts!",
        status: "Scheduled",
    },
    {
        date: "10-11-2024",
        time: "09:37",
        platform: "LinkedIn",
        content: "Announcing Our New Blog Posts!",
        status: "Scheduled",
    },
];

export const engagementMetricesFirstTableData = [
    {
        platform: "Facebook",
        inquiries: 1230,
        avgResponseTime: 2.5,
        responseRate: "95%",
    },
    {
        platform: "Instagram",
        inquiries: 2530,
        avgResponseTime: 3.5,
        responseRate: "99%",
    },
    {
        platform: "LinkedIn",
        inquiries: 1420,
        avgResponseTime: 1.5,
        responseRate: "85%",
    },
    {
        platform: "Facebook",
        inquiries: 190,
        avgResponseTime: 2.5,
        responseRate: "92%",
    },
    {
        platform: "Instagram",
        inquiries: 1780,
        avgResponseTime: 3.5,
        responseRate: "78%",
    },
    {
        platform: "LinkedIn",
        inquiries: 2330,
        avgResponseTime: 1.5,
        responseRate: "88%",
    },
];

export const engagementMetricesByPostTableData = [
    {
        postId: "P-1001",
        platform: "Facebook",
        datePosted: "Oct 4,2024",
        contentPreview: "New Product Post",
        likes: 300,
        comments: 120,
        shares: 50,
        engagementRate: "45%",
    },
    {
        postId: "P-1001",
        platform: "Facebook",
        datePosted: "Oct 4,2024",
        contentPreview: "New Product Post",
        likes: 300,
        comments: 120,
        shares: 50,
        engagementRate: "45%",
    },
    {
        postId: "P-1001",
        platform: "Facebook",
        datePosted: "Oct 4,2024",
        contentPreview: "New Product Post",
        likes: 300,
        comments: 120,
        shares: 50,
        engagementRate: "45%",
    },
    {
        postId: "P-1001",
        platform: "Facebook",
        datePosted: "Oct 4,2024",
        contentPreview: "New Product Post",
        likes: 300,
        comments: 120,
        shares: 50,
        engagementRate: "45%",
    },
    {
        postId: "P-1001",
        platform: "Facebook",
        datePosted: "Oct 4,2024",
        contentPreview: "New Product Post",
        likes: 300,
        comments: 120,
        shares: 50,
        engagementRate: "45%",
    },
    {
        postId: "P-1001",
        platform: "Facebook",
        datePosted: "Oct 4,2024",
        contentPreview: "New Product Post",
        likes: 300,
        comments: 120,
        shares: 50,
        engagementRate: "45%",
    },
];

// Business Management - Stock Monitoring
export const stockMonitoringTableData = [
    {
        productId: "#1234",
        productName: "Lorem ipsum",
        category: "Apparel",
        sellerId: "242323",
        currentStock: 100,
        lowStockThreshold: "200 units",
        status: "In stock",
        restockNeeded: 12,
    },
    {
        productId: "#1234",
        productName: "Lorem ipsum",
        category: "Apparel",
        sellerId: "242323",
        currentStock: 100,
        lowStockThreshold: "200 units",
        status: "In stock",
        restockNeeded: 12,
    },
    {
        productId: "#1234",
        productName: "Lorem ipsum",
        category: "Apparel",
        sellerId: "242323",
        currentStock: 100,
        lowStockThreshold: "200 units",
        status: "In stock",
        restockNeeded: 12,
    },
    {
        productId: "#1234",
        productName: "Lorem ipsum",
        category: "Apparel",
        sellerId: "242323",
        currentStock: 100,
        lowStockThreshold: "200 units",
        status: "In stock",
        restockNeeded: 12,
    },
    {
        productId: "#1234",
        productName: "Lorem ipsum",
        category: "Apparel",
        sellerId: "242323",
        currentStock: 100,
        lowStockThreshold: "200 units",
        status: "In stock",
        restockNeeded: 12,
    },
    {
        productId: "#1234",
        productName: "Lorem ipsum",
        category: "Apparel",
        sellerId: "242323",
        currentStock: 100,
        lowStockThreshold: "200 units",
        status: "In stock",
        restockNeeded: 12,
    },
    {
        productId: "#1234",
        productName: "Lorem ipsum",
        category: "Apparel",
        sellerId: "242323",
        currentStock: 100,
        lowStockThreshold: "200 units",
        status: "In stock",
        restockNeeded: 12,
    },
];

export const reportingInsightsTableData = [
    {
        category: "Footwear",
        averageMonthlySales: "$5600",
        stockTurnover: "365 days",
        topLowStock: 100,
        restockNeeded: 100,
    },
    {
        category: "Footwear",
        averageMonthlySales: "$5600",
        stockTurnover: "365 days",
        topLowStock: 100,
        restockNeeded: 100,
    },
    {
        category: "Footwear",
        averageMonthlySales: "$5600",
        stockTurnover: "365 days",
        topLowStock: 100,
        restockNeeded: 100,
    },
    {
        category: "Footwear",
        averageMonthlySales: "$5600",
        stockTurnover: "365 days",
        topLowStock: 100,
        restockNeeded: 100,
    },
];

export const ordertransactionsTableData = [
    {
        transId: "TX-100001",
        orderId: "#907807",
        customerName: "John Doe",
        date: "Oct 4,2090",
        amount: "$365",
        transType: "Purchase",
        paymentMethod: "Paypal",
        status: "Paid",
    },
    {
        transId: "TX-100001",
        orderId: "#907807",
        customerName: "John Doe",
        date: "Oct 4,2090",
        amount: "$365",
        transType: "Purchase",
        paymentMethod: "Paypal",
        status: "Paid",
    },
    {
        transId: "TX-100001",
        orderId: "#907807",
        customerName: "John Doe",
        date: "Oct 4,2090",
        amount: "$365",
        transType: "Purchase",
        paymentMethod: "Paypal",
        status: "Paid",
    },
    {
        transId: "TX-100001",
        orderId: "#907807",
        customerName: "John Doe",
        date: "Oct 4,2090",
        amount: "$365",
        transType: "Purchase",
        paymentMethod: "Paypal",
        status: "Paid",
    },
    {
        transId: "TX-100001",
        orderId: "#907807",
        customerName: "John Doe",
        date: "Oct 4,2090",
        amount: "$365",
        transType: "Purchase",
        paymentMethod: "Paypal",
        status: "Paid",
    },
];

export const purchaseHistoryTableData = [
    {
        orderId: "#907807",
        customerName: "John Doe",
        status: "Pending",
        amount: "$365",
        paymentMethod: "Paypal",
        address: "Purchase",
    },
    {
        orderId: "#907807",
        customerName: "John Doe",
        status: "Completed",
        amount: "$365",
        paymentMethod: "Paypal",
        address: "Purchase",
    },
    {
        orderId: "#907807",
        customerName: "John Doe",
        status: "Pending",
        amount: "$365",
        paymentMethod: "Paypal",
        address: "Purchase",
    },
    {
        orderId: "#907807",
        customerName: "John Doe",
        status: "Completed",
        amount: "$365",
        paymentMethod: "Paypal",
        address: "Purchase",
    },
];

export const transactionInsightsTableData = [
    {
        period: "Nov,2024-Oct,2024",
        totalTrans: "1,534",
        totalRevenue: "$3500",
        refunds: "34",
        failedTrans: 15,
    },
    {
        period: "Nov,2024-Oct,2024",
        totalTrans: "1,534",
        totalRevenue: "$3500",
        refunds: "34",
        failedTrans: 15,
    },
    {
        period: "Nov,2024-Oct,2024",
        totalTrans: "1,534",
        totalRevenue: "$3500",
        refunds: "34",
        failedTrans: 15,
    },
    {
        period: "Nov,2024-Oct,2024",
        totalTrans: "1,534",
        totalRevenue: "$3500",
        refunds: "34",
        failedTrans: 15,
    },
    {
        period: "Nov,2024-Oct,2024",
        totalTrans: "1,534",
        totalRevenue: "$3500",
        refunds: "34",
        failedTrans: 15,
    },
];

export const refundTransactionsTableData = [
    {
        transId: "#124",
        returnId: "#4534",
        customerName: "John DOe",
        sellerName: "John",
        refundAmount: 150,
        refundMethod: "Debit Card",
        requestDate: "Nov 4, 2090",
        status: "Paid",
    },
    {
        transId: "#124",
        returnId: "#4534",
        customerName: "John DOe",
        sellerName: "John",
        refundAmount: 150,
        refundMethod: "Debit Card",
        requestDate: "Nov 4, 2090",
        status: "Assign",
    },
    {
        transId: "#124",
        returnId: "#4534",
        customerName: "John DOe",
        sellerName: "John",
        refundAmount: 150,
        refundMethod: "Debit Card",
        requestDate: "Nov 4, 2090",
        status: "Paid",
    },
    {
        transId: "#124",
        returnId: "#4534",
        customerName: "John DOe",
        sellerName: "John",
        refundAmount: 150,
        refundMethod: "Debit Card",
        requestDate: "Nov 4, 2090",
        status: "Paid",
    },
];

export const refundRequestListTableData = [
    {
        reqId: "#124",
        orderId: "#4534",
        customerName: "John DOe",
        sellerName: "John",
        refundAmount: 150,
        refundMethod: "Debit Card",
        requestDate: "Nov 4, 2090",
        status: "Assign",
    },
    {
        reqId: "#124",
        orderId: "#4534",
        customerName: "John DOe",
        sellerName: "John",
        refundAmount: 150,
        refundMethod: "Debit Card",
        requestDate: "Nov 4, 2090",
        status: "Assign",
    },
    {
        reqId: "#124",
        orderId: "#4534",
        customerName: "John DOe",
        sellerName: "John",
        refundAmount: 150,
        refundMethod: "Debit Card",
        requestDate: "Nov 4, 2090",
        status: "Assign",
    },
    {
        reqId: "#124",
        orderId: "#4534",
        customerName: "John DOe",
        sellerName: "John",
        refundAmount: 150,
        refundMethod: "Debit Card",
        requestDate: "Nov 4, 2090",
        status: "Assign",
    },
];

export const messagesListTableData = [
    {
        msgId: "#124",
        sender: "John",
        recepient: "John DOe",
        userType: "Admin",
        subject: "Order Cancellation",
        recDate: "10 oct, 2090",
        status: "In transit",
    },
    {
        msgId: "#124",
        sender: "John",
        recepient: "John DOe",
        userType: "Admin",
        subject: "Order Cancellation",
        recDate: "10 oct, 2090",
        status: "Pending",
    },
    {
        msgId: "#124",
        sender: "John",
        recepient: "John DOe",
        userType: "Admin",
        subject: "Order Cancellation",
        recDate: "10 oct, 2090",
        status: "In transit",
    },
    {
        msgId: "#124",
        sender: "John",
        recepient: "John DOe",
        userType: "Admin",
        subject: "Order Cancellation",
        recDate: "10 oct, 2090",
        status: "In transit",
    },
];

export const supportTickerTableData = [
    {
        ticketId: "#124",
        userType: "Admin",
        userName: "Admin",
        subject: "Order Cancellation",
        priority: "High",
        status: "Open",
        createdDate: "20-10-290",
        lastUpdate: "20-10-290",
        assignedTo: "John",
        actions: "Assign",
    },
    {
        ticketId: "#124",
        userType: "Admin",
        userName: "Admin",
        subject: "Order Cancellation",
        priority: "High",
        status: "Open",
        createdDate: "20-10-290",
        lastUpdate: "20-10-290",
        assignedTo: "John",
        actions: "View",
    },
    {
        ticketId: "#124",
        userType: "Admin",
        userName: "Admin",
        subject: "Order Cancellation",
        priority: "High",
        status: "Open",
        createdDate: "20-10-290",
        lastUpdate: "20-10-290",
        assignedTo: "John",
        actions: "Assign",
    },
];

export const feedbackTableData = [
    {
        id: "#124",
        userName: "Admin",
        rating: "Order Cancellation",
        type: "bug",
        subject: "Login issue",
        dateSubmitted: "20-10-290",
        status: "Open",
        actions: "View",
    },
    {
        id: "#124",
        userName: "Admin",
        rating: "Order Cancellation",
        type: "bug",
        subject: "Login issue",
        dateSubmitted: "20-10-290",
        status: "Open",
        actions: "Resolve",
    },
    {
        id: "#124",
        userName: "Admin",
        rating: "Order Cancellation",
        type: "bug",
        subject: "Login issue",
        dateSubmitted: "20-10-290",
        status: "Open",
        actions: "View",
    },
];

export const FAQsTableData = [
    {
        category: "Customer Service",
        subCategory: "Order Issues",
        question: "Question will be shown here?",
        answer: "Asnwer will be shown here",
        ranking: "1",
        status: "Online",
    },
    {
        category: "Customer Service",
        subCategory: "Order Issues",
        question: "Question will be shown here?",
        answer: "Asnwer will be shown here",
        ranking: "1",
        status: "Online",
    },
    {
        category: "Customer Service",
        subCategory: "Order Issues",
        question: "Question will be shown here?",
        answer: "Asnwer will be shown here",
        ranking: "1",
        status: "Online",
    },
    {
        category: "Customer Service",
        subCategory: "Order Issues",
        question: "Question will be shown here?",
        answer: "Asnwer will be shown here",
        ranking: "1",
        status: "Online",
    },
];
